import {BaseModel} from "../base/base.model";
export class LoginModel extends BaseModel{
    email: string;
    password: string;
}


// WEBPACK FOOTER //
// ./src/app/models/auth/auth.model.ts